export default __webpack_public_path__ + "static/media/22.87ae7827.jpg";